import { style, styleVariants } from '@vanilla-extract/css';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { borderWidthVars } from '@tundr/ds-foundations';
import { BASE_TRANSITION } from '../_shared/styles/motion';
import { TundrLogoVariant } from './TundrLogo.types';

const DARK_WIDTH = '55px';
const SMALL_DARK_WIDTH = '20px';

export const logoClass = style({
  objectFit: 'cover',
});

export const logoWidthClass = styleVariants({
  [TundrLogoVariant.Light]: { width: '100%' },
  [TundrLogoVariant.Dark]: { width: DARK_WIDTH },
  [TundrLogoVariant.Small]: { width: '100%' },
  [TundrLogoVariant.SmallDark]: { width: SMALL_DARK_WIDTH },
});

export const clickableClass = style({
  cursor: 'pointer',
  transition: `scale ${BASE_TRANSITION}`,
  selectors: {
    '&:hover': { scale: 1.03 },
    '&:active': { scale: 1 },
    '&:focus-visible': {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.border.brand.base}`,
      outlineOffset: '2px',
    },
  },
  '@media': {
    '(prefers-reduced-motion: reduce)': { transition: 'none' },
  },
});
